import Vue from 'vue';
import productGroupTransformer from './../../transformers/productGroup';
import store from './../../store';

const success = ({ data }) => productGroupTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const productGroups = store.state.productGroup.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (productGroups.length > 0) {
      return resolve(productGroups[0]);
    }

    return Vue.$http.get(`/product_groups/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product-group/show.js